import React from "react";
import Tooltip from "../tooltip/tooltip";
import { FaQuestionCircle } from "react-icons/fa";
import "./input.scss";
import classNames from "classnames";
import { withDefaults } from "../../utils/withDefaults";
import type { Placement } from "@popperjs/core";

export interface InputLabelProps {
  label?: string;
  helpText?: string;
  helpTextPlacement?: Placement;
  className?: string;
  additionalIconComponent?: React.ReactNode;
  isRequired?: boolean;
}

export default function InputLabel(incomingProps: InputLabelProps) {
  const props = withDefaults(incomingProps, inputLabelDefaultProps);

  return (
    <span
      className={classNames("input-label", props.className)}
      data-testid="input-label"
    >
      <strong>{props.label}</strong>
      {props.isRequired ? <span className="asterisk"> *</span> : null}
      {props.helpText ? (
        <Tooltip
          tooltipMessage={props.helpText}
          placement={props.helpTextPlacement}
          referenceStyle={{ display: "inline-block" }}
        >
          <FaQuestionCircle
            className="help-text-icon"
            data-testid="help-text-icon"
          />
        </Tooltip>
      ) : null}
      {props.additionalIconComponent}
    </span>
  );
}

const inputLabelDefaultProps = {
  label: "",
  helpText: "",
  helpTextPlacement: "bottom" as Placement,
  className: "",
  additionalIconComponent: null
};
